const PIXEL_ID = '2311057319286144'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

function loadPixelScript() {
  if (window.fbq) return

  const n: any = (window.fbq = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)
}

export function initMetaPixel() {
  loadPixelScript()
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCart(e: React.MouseEvent<HTMLAnchorElement>) {
  e.preventDefault()
  const href = (e.currentTarget as HTMLAnchorElement).href

  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }

  // Give the pixel request time to fire before navigating
  setTimeout(() => {
    window.location.href = href
  }, 400)
}
